export default Object.freeze({
  TITLE: '쇼핑몰 정산 데이터 생성',
  LOOKUP_PERIOD: '조회 기간',
  SHIPPING_COST_INCLUDED: '배송비 포함 여부',
  INCLUDE: '포함',
  NOT_INCLUDE: '미포함',
  DATE_MAX_RANGE: '조회기간은 최대 3개월까지 가능합니다.',
  NOTICE_1: '쇼핑몰 정산 데이터는 \'배송중\' 상태를 기점으로 데이터가 쌓입니다',
  NOTICE_2: '쇼핑몰 정산 시점은 파트너 정산 시점 설정과 관련이 없습니다.',
  NOTICE_3: '쇼핑몰 정산 시점 변경이 필요한 경우 1:1문의를 통해 요청해 주세요.\n(단, 쇼핑몰 정산 시점 변경 시 수정 이전에 해당 시점으로 변경된 주문은 정산 내역에서 누락됩니다.)',
});
